import { apiV2 } from '../api'
import { FeatureFlag, FeatureFlagEntidadeParams } from './dtos/entitys'

export const featureFlagEntidades = async ({
  featureFlag,
}: FeatureFlagEntidadeParams): Promise<FeatureFlag> => {
  const { data } = await apiV2.get<FeatureFlag>(
    `/canais/entidades/${featureFlag}`
  )

  return data
}
